import { render } from "./ProtocolExtraction.vue?vue&type=template&id=eeb856e6&scoped=true"
import script from "./ProtocolExtraction.js?vue&type=script&lang=js"
export * from "./ProtocolExtraction.js?vue&type=script&lang=js"

import "./ProtocolExtraction.vue?vue&type=style&index=0&id=eeb856e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb856e6"]])

export default __exports__